import { apiClient } from '@/lib/api/api-client'
import type { AuthMe } from '../types/auth'

const AUTH_ENDPOINT = '/auth'

export const authApi = {
  login: (username: string, password: string) => {
    return apiClient.post<string>(`${AUTH_ENDPOINT}/login`, { username, password }, undefined, true)
  },

  changePassword: (payload: { oldPassword: string; newPassword: string }) => {
    return apiClient.post<void>(`${AUTH_ENDPOINT}/change-password`, payload)
  },

  resetPassword: (userId: string) => {
    return apiClient.post<string>(`${AUTH_ENDPOINT}/${userId}/reset-password`)
  },

  logout: () => apiClient.post<void>(`${AUTH_ENDPOINT}/logout`, undefined, undefined, false, true),

  me: (token?: string) =>
    apiClient.get<AuthMe>(`${AUTH_ENDPOINT}/me`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
}
